export default __webpack_public_path__ + "static/media/i3.eab7da3a.png";